import { AnalyticPeriodsEnum } from '@workalizer/shared/enums';
import { resolveGeminiUsageLevelPeriod } from '@workalizer/shared/lib/gemini-usage-level/period';
import { formatPeriod } from '@workalizer/shared/utils';
import { addDays, format, parseISO } from 'date-fns';
export var GEMINI_ADOPTION_TREND_MIN_WEEKS = 2;
export var isGeminiAdoptionTrendVisible = function (dateFrom, dateTo, minWeeks) {
    if (minWeeks === void 0) { minWeeks = GEMINI_ADOPTION_TREND_MIN_WEEKS; }
    var periodInfo = resolveGeminiUsageLevelPeriod(dateFrom, dateTo);
    return periodInfo.isValid && periodInfo.weekCount >= minWeeks;
};
export var getGeminiAdoptionTrendWeekPeriods = function (dateFrom, dateTo, minWeeks) {
    if (minWeeks === void 0) { minWeeks = GEMINI_ADOPTION_TREND_MIN_WEEKS; }
    var periodInfo = resolveGeminiUsageLevelPeriod(dateFrom, dateTo);
    if (!periodInfo.isValid || periodInfo.weekCount < minWeeks) {
        return [];
    }
    var start = parseISO(periodInfo.effectiveDateFrom);
    var weeks = [];
    for (var weekIndex = 0; weekIndex < periodInfo.weekCount; weekIndex += 1) {
        var weekStart = addDays(start, weekIndex * 7);
        var weekEnd = addDays(weekStart, 6);
        weeks.push({
            period: formatPeriod(AnalyticPeriodsEnum.WEEK, weekStart, weekEnd),
            dateFrom: format(weekStart, 'yyyy-MM-dd'),
            dateTo: format(weekEnd, 'yyyy-MM-dd')
        });
    }
    return weeks;
};
